//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function exportService (term, filterStatus, filterTag) {
  if(term ===  null || term === undefined) term = "";
  if(filterStatus ===  null || filterStatus === undefined) filterStatus = "";
  if(filterTag ===  null || filterTag === undefined) filterTag = "";
  try {
    const response = await api.get(`/leads/exportar?&busca=${encodeURIComponent(term)}&status=${filterStatus}&tag=${filterTag}`);
    return response;
  } catch (error) {
    toast.error("Erro ao exportar leads");
    return null;
  }
}